var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M0 0h53.3v20.3H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M0 19.7h53.3V40H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "M19 12.4c13.8 3.6 5 21.2-5.9 13.9l-.7 1.1a9.2 9.2 0 0 0 14.5-3.8c1.8-5-.7-11.8-7.7-12.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "m14.2 27.6 1.8.8-.9 1.8-1.8-.8zm12.4-8.3h2v2h-2zm-1-3.3 1.9-.7.7 1.9-1.9.7zm-2.2-2.4 1.5-1.4 1.4 1.4-1.4 1.4zm-2.1-3.3 1.8.7-.7 1.9-1.8-.7zm5 12.2 1.9.7-.8 1.9-1.8-.7zm-5.8 5.8 1.8-.7.8 1.8-1.8.8zm-3.3.3h2v2h-2zm3.5-9.7L19 17.7l-1.7 1.2.6-2-1.6-1.2h2l.7-1.9.6 2 2.1-.1-1.6 1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe0",
    fillRule: "evenodd",
    d: "m28 28.9-.8 1.5h.3q1.6.6 2.2 1.5h.8l.6-.3q.3-.6-.2-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M30.4 31a.4.4 0 1 1-.6-.2.4.4 0 0 1 .6.3m-1.7-1a.4.4 0 1 1-.8 0 .4.4 0 0 1 .8 0m.9.5a.4.4 0 1 1-.8 0 .4.4 0 0 1 .8 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe0",
    fillRule: "evenodd",
    d: "m27 30.3-10.8-6.2c-1.6-1-1.6-2.8-.6-4.2q.2-.2.3 0 .2 1 1 1.8l11 7.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffec00",
    fillRule: "evenodd",
    d: "m24.8 25.5 1.4 1.3-1.3 1.5-1.5-1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m27.6 29-10.4-6.2m9.1 4.8-3.5-2.3m1.5 3.6-3.5-2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/ao.75217f405d4ce72779cf75009727aa54.svg";
export { ForwardRef as ReactComponent };